import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '../../components/Buttons';
import React from 'react';
import { CompanyMessageModel } from '../../data/models/CompanyMessageModel';
import { Avatar, ListItem, ListItemAvatar, ListItemText, makeStyles } from '@material-ui/core';
import { parseColour } from '../../utils/utilities'
import MessageIcon from '@material-ui/icons/Message'
import ListItemBase from '../../components/list-items/ListItemBase';
import { FormattedMessage } from 'react-intl'
import { useDateTimeFormat } from 'utils/useDateTimeFormat'
import { useSelector } from 'react-redux'
import { IRootReduxState } from 'types/reducers'

type StyleProps = { isDarkMode: boolean }

const useStyles = makeStyles({
  messageContent: {
    color: (props: StyleProps) => props.isDarkMode ? '#ffffff' : 'inherit',
    '& *': {
      color: (props: StyleProps) => props.isDarkMode ? '#ffffff' : 'inherit',
    }
  }
})

interface Props  {
    open : boolean,
    item? : CompanyMessageModel,
    handleClose?: ()=> void
}

const CompanyMessageDialog: React.FC<Props> = ({ open, item, handleClose }) => {
  const [isClosing, setIsClosing] = React.useState(false)
  const { formatDateTime } = useDateTimeFormat()
  const isDarkMode = useSelector((state: IRootReduxState) => state.app.user.theme === 'dark')
  const classes = useStyles({ isDarkMode })
  const authorName = [item?.FirstName, item?.LastName].filter(Boolean).join(' ').trim()

  const handleOkClick = () => {
    if (isClosing) return; // Prevent multiple clicks
    setIsClosing(true);
    handleClose && handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
      <FormattedMessage id="companyMessage.title" defaultMessage="Company message" /> <br />
      <ListItemBase>
        <ListItem>
            <ListItemAvatar>
                <Avatar style={{ backgroundColor: '#163A64' }}>
                    <MessageIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <FormattedMessage
                  id="companyMessage.username"
                  defaultMessage="Message from {name}"
                  values={{ name: authorName || '—' }}
                />
              }
              secondary={
                <FormattedMessage
                  id="companyMessage.createdOn"
                  defaultMessage="Created on {date}"
                  values={{ date: formatDateTime(item?.CreatedOn) }}
                />
              }
            />
        </ListItem>
    </ListItemBase>
      </DialogTitle>
      <DialogContent>
      <span className={classes.messageContent} dangerouslySetInnerHTML={{__html: item?.Message || ''}} />
      </DialogContent>
      <DialogActions>
      <Button.OkButton 
        click={handleOkClick}
        disabled={isClosing}
        disableOnClick={true}
      />
      </DialogActions>
    </Dialog>
  );
};

export default CompanyMessageDialog;
